import React, {useEffect} from 'react';
import {
    createBrowserRouter,
    RouterProvider,
} from 'react-router-dom';
import {detectAnyAdblocker} from 'just-detect-adblock';

import Footer from './partials/Footer';
import isMobile from 'ismobilejs';
import SizeSVG from './SizeSVG';
import Home from './components/pages/Home';
import Detail from './components/pages/Detail';

function App() {
    const basename = process.env.REACT_APP_BASENAME;

    useEffect(() => {
        if (!isMobile().phone && window.outerWidth > 1000) {
            const svgs = document.querySelectorAll('svg:not(.no--resize)');

            Object.values(svgs).map(svg => SizeSVG(svg));
        }
    }, []);

    useEffect(() => {
        detectAnyAdblocker().then(detected => {
            if (detected) {
                const adButtons = document.querySelectorAll('[href*="https://ad.doubleclick.net/"]');
                const newUrl = 'https://www.etoro.com/fr/investing/portfolios/?utm_medium=Content%20Partnerships&utm_source=109189&utm_content=20517&utm_serial=358217871&utm_campaign=358217871&utm_term=&Source=Media&dclid=CjkKEQiAw8OeBhDf3s_Wl4qgq7kBEiQApYgWHrIUtan9hKn7JXLVRGk9A1juhDo2JRFfxrAAheuoD3nw_wcB#our-portfolios';

                Object.values(adButtons).map(button => button.href = newUrl);
            }
        });
    }, []);

    const router = createBrowserRouter([
        {
            path: "",
            element: <Home/>,
        },
        {
            path: "evenement/:slug",
            element: (<Detail/>),
        },
    ], {
        basename: basename
    });

    return (
        <main className="App">
            <RouterProvider router={router} />
            <Footer/>
        </main>
    );
}

export default App;
